import SectionTitle from '@/components/feature/SectionTitle';
import { testimonials } from '@/mocks/site';

export default function VoicesSection() {
  return (
    <section id="voices" className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <SectionTitle
        eyebrow="读者口碑"
        title="他们这样用揭秘局的图解"
        desc="来自撰稿人、品牌舆情岗与节目策划的真实反馈。"
        align="center"
      />
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {testimonials.map((item) => (
          <figure key={item.name} className="rounded-lg bg-background-50 border border-background-200/80 p-6 flex flex-col">
            <i className="ri-double-quotes-l text-2xl text-accent-500" />
            <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">{item.quote}</blockquote>
            <figcaption className="mt-5 pt-4 border-t border-background-200/70">
              <div className="font-heading text-sm font-bold text-foreground-950">{item.name}</div>
              <div className="mt-0.5 text-xs text-secondary-700">{item.role}</div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}